import { useEffect, useState } from 'react'

import { useFormNoChangesNotification } from '../../components/Form'
import { NotificationInlineList } from '../../components/Notification'
import { useScrollToInlineNotifications } from '../useScrollToInlineNotifications'
import { useYupValidationWithoutFormik } from '../useYupValidationWithoutFormik'

import * as styles from './useValidationWithoutFormikNotifications.module.css'

export function useValidationWithoutFormikNotifications({
  getValidationSchema,
  notifications,
  validateData,
  validationSchemaProps,
  onRemoveNotification,
  onSetNotification,
}) {
  const [hasNotificationList, setHasNotificationList] = useState(false)

  const { isValidForm, setValidationErrors, validationErrors } =
    useYupValidationWithoutFormik({
      getValidationSchema,
      validateData,
      validationSchemaProps,
    })

  const { ref, setScrollToNotifications } = useScrollToInlineNotifications()

  useFormNoChangesNotification({
    errors: validationErrors,
    onRemoveNotification,
    onSetNotification,
  })

  function setNotificationListRef(node) {
    ref.current = node

    setHasNotificationList(!!node)
  }

  useEffect(() => {
    if (Object.keys(validationErrors).length > 0 && hasNotificationList) {
      setScrollToNotifications(prev => ++prev)
    }
  }, [hasNotificationList, validationErrors])

  const notificationList =
    notifications?.length > 0 ? (
      <NotificationInlineList
        className={styles.notifications}
        items={notifications}
        notificationClassName={styles.notification}
        ref={setNotificationListRef}
      />
    ) : null

  return {
    isValidForm,
    notificationList,
    setNotificationListRef,
    setValidationErrors,
    validationErrors,
  }
}
